import { SvgIcon } from '@mui/material';

export const CollapseIcon = () => (
  <SvgIcon viewBox="0 0 14 14" width="12" height="12">
    <path d="M6 8V14H4V10H0V8H6ZM10 0V4H14V6H8V0H10Z" fill="#EC6A7A" />
  </SvgIcon>
);
